// extracted by mini-css-extract-plugin
module.exports = {"root":"RulesForm_root__33lHF","sidebar":"RulesForm_sidebar__3wuN2"};